import SourceOfAppService from "@/service/SourceOfAppService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { SourceOfApp } from "@/model/SourceOfApp";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import sourceOfAppValidationObj from "./S080500-SourceOfAppValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var sourceOfAppDataValidationObj = new sourceOfAppValidationObj();
export default {
  name: "sourceOfApp",
  mounted() {
    sourceOfAppDataValidationObj.sourceOfAppValidation();
    this.assignRights();
    this.resetSourceOfAppData();
    this.init();
    this.getAllSourceOfApps();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    dictEnum: dictEnum,
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_SourceofAppli,
    Settings: Settings,
    sourceOfApp: new SourceOfApp(),
    isEditMode: false,
    sourceOfAppList: [],
    selectAllSourceOfApp: false,
    tempSourceOfAppModel: new SourceOfApp(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".sourceOfApp-table table thead").height();
      var pagginationHeight = $(".paggination-sourceOfApp").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllSourceOfApps() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await SourceOfAppService.getAllSourceOfAppsByPagination(obj);
      if (response.data.IsSuccess) {
        this.sourceOfAppList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllSourceOfAppRecord: function () {
      var self = this;
      var IsSelected = self.selectAllSourceOfApp;
      self.sourceOfAppList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleSourceOfAppPopup: function () {
      var arrayList = [];
      var self = this;
      self.sourceOfAppList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteSourceOfAppModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleSourceOfApp() {
      var arrayList = [];
      var self = this;
      $('#deleteSourceOfAppModel').modal('hide');
      self.sourceOfAppList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        sourceOfAppList: arrayList,
      };
      const response = await SourceOfAppService.deleteSourceOfApp(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetSourceOfAppData();
        self.init();
        await self.getAllSourceOfApps();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnSourceOfAppSelect: function (model) {
      this.tempSourceOfAppModel = model;
    },
    addSourceOfApp: function () {
      var self = this;
      $('#sourceOfAppModel').modal('show');
      self.isEditMode = false;
      self.sourceOfApp = new SourceOfApp();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async getSourceOfAppDetail() {
      var self = this;
      const obj = {
        SACode: self.tempSourceOfAppModel.SACode,
      };
      const response = await SourceOfAppService.getSourceOfAppDetail(obj);
      if (response.data.IsSuccess) {
        self.sourceOfApp = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveSourceOfAppData(obj) {
      var self = this;
      const response = await SourceOfAppService.addSourceOfApp(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetSourceOfAppData();
        self.init();
        await self.getAllSourceOfApps();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async editSourceOfAppData(obj) {
      var self = this;
      const response = await SourceOfAppService.updateSourceOfApp(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetSourceOfAppData();
        self.init();
        await self.getAllSourceOfApps();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveSourceOfApp() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#sourceOfAppModel').modal('hide');
          const obj = {
            model: {
              SACode: self.sourceOfApp.SACode,
              CDesc: self.sourceOfApp.CDesc,
              EDesc: self.sourceOfApp.EDesc,
              SpecReq: self.sourceOfApp.SpecReq
            }
          };
          if (self.isEditMode) {
            self.editSourceOfAppData(obj);
          }
          else {
            self.saveSourceOfAppData(obj);
          }
        }
      });
    },
    async editSourceOfApp() {
      var self = this;
      self.isEditMode = true;
      if (self.tempSourceOfAppModel.SACode != "") {
        await self.getSourceOfAppDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#sourceOfAppModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetSourceOfAppData: function () {
      var self = this;
      self.selectAllSourceOfApp = false;
      self.isEditMode = false;
      self.sourceOfApp = new SourceOfApp();
      self.tempSourceOfAppModel = new SourceOfApp();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeSourceOfAppPopup: function () {
      var self = this;
      self.selectAllSourceOfApp = false;
      self.isEditMode = false;
      self.sourceOfApp = new SourceOfApp();
      self.tempSourceOfAppModel = new SourceOfApp();
      self.$validator.reset();
      self.vErrors.clear();
      $('#sourceOfAppModel').modal('hide');
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllSourceOfApps();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080500-SourceOfApp/S080500-SourceOfApp.js